import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import portalService from '../../services/portalService';
import { usePortalAuth } from '../../context/PortalAuthContext';
import { useLanguage, t } from '../../context/LanguageContext';

export default function PortalChangePasswordPage() {
  const { clearMustChange } = usePortalAuth();
  const { lang } = useLanguage();
  const navigate = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (next.length < 6) { setError(t('New password must be at least 6 characters.', 'La nueva contraseña debe tener al menos 6 caracteres.', lang)); return; }
    if (next !== confirm) { setError(t('Passwords do not match.', 'Las contraseñas no coinciden.', lang)); return; }
    setLoading(true);
    try {
      await portalService.changePassword(current, next);
      clearMustChange();
      navigate('/portal');
    } catch (err) {
      setError(err.response?.data?.message || t('Failed to change password.', 'Error al cambiar la contraseña.', lang));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', background: '#f4f6fa', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16 }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div className="text-center mb-4">
          <h4 className="fw-bold mb-1">{t('Set Your Password', 'Establecer contraseña', lang)}</h4>
          <p className="text-muted" style={{ fontSize: 13 }}>{t('You must set a new password before continuing.', 'Debe establecer una nueva contraseña antes de continuar.', lang)}</p>
        </div>
        <div className="card shadow-sm">
          <div className="card-body p-4">
            {error && <div className="alert alert-danger" style={{ fontSize: 13 }}>{error}</div>}
            <form onSubmit={handleSubmit}>
              <div className="mb-3">
                <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('Current (temporary) password', 'Contraseña actual (temporal)', lang)}</label>
                <input type="password" className="form-control" value={current} onChange={e => setCurrent(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>
                  {t('New password', 'Nueva contraseña', lang)}{' '}
                  <span className="text-muted fw-normal">({t('min 6 characters', 'mín. 6 caracteres', lang)})</span>
                </label>
                <input type="password" className="form-control" value={next} onChange={e => setNext(e.target.value)} required />
              </div>
              <div className="mb-4">
                <label className="form-label" style={{ fontSize: 13, fontWeight: 600 }}>{t('Confirm new password', 'Confirmar nueva contraseña', lang)}</label>
                <input type="password" className="form-control" value={confirm} onChange={e => setConfirm(e.target.value)} required />
              </div>
              <button className="btn btn-primary w-100" disabled={loading}>
                {loading ? t('Saving…', 'Guardando…', lang) : t('Set Password', 'Establecer contraseña', lang)}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
